<h1 mat-dialog-title class="col-12 save-report-dialogTitle">{{data.dialogTitle}}</h1>

<ng-template [ngIf]="data.id === 0">
  <mat-form-field class="col-12">
    <input matInput [(ngModel)]="data.filename" placeholder="Filename" class="save-report-inputs">
  </mat-form-field>
</ng-template>

<ng-template [ngIf]="data.id > 0">
  <mat-radio-group aria-label="Select an option" [(ngModel)]="data.selectedOption">
    <mat-radio-button value="1" class="save-report-inputs">Replace Existing File</mat-radio-button>
    <br />
    <mat-radio-button value="2" class="save-report-inputs">Save as New File:</mat-radio-button>
  </mat-radio-group>
  <br />
  <input class="save-report-inputs"
         matInput placeholder="Enter New Filename"
         disabled="{{data.selectedOption != 2}}"
         [(ngModel)]="data.newFilename">
  <mat-error *ngIf="recordExists">Filename already exists.</mat-error>
</ng-template>


<div class="col-12 mb-3 mt-3">
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="onClickCancel()" class="save-report-dialogCancelButton">Cancel</button>
    <button mat-raised-button color="primary" (click)="onClickSave()" cdkFocusInitial class="save-report-dialogSaveButton">Ok</button>
  </mat-dialog-actions>
</div>
